import { type WheelEventHandler } from './wheel-event-handler';

/**
 * Timeout to use to determine end of pan gesture.
 */
const PAN_GESTURE_TIMEOUT_MS = 150;

export class PanHandler implements WheelEventHandler {
  private timeoutId: number | null = null;

  constructor(
    private forwardToBridge: (event: WheelEvent) => void,
    private onGestureEnd: () => void
  ) {}

  public canHandle(_event: WheelEvent): boolean {
    // Always handles all events. This handler assumes other handlers (e.g. zoom, scroll)
    // tried and was not able to process this wheel event
    return true;
  }

  public start(_event: WheelEvent): void {}

  public handleEvent(event: WheelEvent): void {
    // Forward event to bridge to be handled by parent container (e.g. WB)
    this.forwardToBridge(event);

    // Reset timeout on each event to keep the gesture alive. This implements a debouncing
    // mechanism: as long as wheel events continue, the timeout is pushed back. Only when
    // events stop for PAN_GESTURE_TIMEOUT_MS does the timeout fire, signaling gesture end.
    this.resetTimeout();
  }

  cleanup(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  private resetTimeout(): void {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId);
    }

    // Inform parent that gesture has ended. In the absence of a "pan-end"
    // like event, we use a timeout to determine when the gesture has ended
    this.timeoutId = window.setTimeout(() => {
      this.onGestureEnd();
    }, PAN_GESTURE_TIMEOUT_MS);
  }
}
